import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, Icon } from '../ui';
import { PLAN_LINKS } from '../../data/home';

export default function PlanPilgrimage() {
  const { t } = useTranslation();
  return (
    <aside className="plan card" aria-labelledby="plan-title">
      <div className="plan__head"><h2 id="plan-title" className="plan__title">{t('Plan Your Pilgrimage')}</h2></div>
      <ul className="plan__list">
        {PLAN_LINKS.map((p) => (
          <li key={p.title}>
            <Link to={p.to} className="plan__row">
              <span className="plan__icon"><Icon name={p.icon} size={20} /></span>
              <span>
                <span className="plan__t">{t(p.title)}</span>
                <span className="plan__s" style={{ display: 'block' }}>{t(p.sub)}</span>
              </span>
              <Icon name="chevron-right" size={18} />
            </Link>
          </li>
        ))}
      </ul>
      <div className="plan__foot">
        <Button variant="outline" to="/travel-guide" icon={<Icon name="map" size={18} />}>{t('View Travel Guide')}</Button>
      </div>
    </aside>
  );
}
